// The red number on My Work (item #650, TCSD-0189 ruling 7): things to do in the
// person's starting view, counted by the database (get_my_work_count) from the
// same rows My Work lists. News never moves it. Refreshes when any table those
// rows read is written.
import { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabase';
import { useAuth } from './auth';
import { useReader } from './save-path';

export function useMyWorkCount(): number {
  const { user, profile } = useAuth();
  const eid = profile?.employee_id ?? null;
  const [n, setN] = useState(0);
  const [tick, setTick] = useState(0);
  const bump = useCallback(() => setTick((t) => t + 1), []);
  useReader(['projects', 'facilities', 'service_assignments', 'notification_recipients', 'my_work_dismissals', 'record_routing', 'new_account_sop'], bump);
  // Gate on the employee id, not the Firebase user: the database token is only in
  // place once the employee id is (see use-notification-badge.ts).
  useEffect(() => {
    if (!user || !eid) {
      setN(0);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.rpc('get_my_work_count');
      if (cancelled) return;
      setN(!error && typeof data === 'number' ? data : 0);
    })();
    return () => {
      cancelled = true;
    };
  }, [user, eid, tick]);
  return n;
}
